import { render, staticRenderFns } from "./ProcessedImagesContent.vue?vue&type=template&id=6bd487ce"
import script from "./ProcessedImagesContent.vue?vue&type=script&lang=js"
export * from "./ProcessedImagesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports